import { createAction, props } from '@ngrx/store';
import {
  AdminOrganizationAttrs,
  AdminOrganizationAttrsValues,
} from 'src/app/admin/models/organization.model';
import { AdminOrganizationAttrsApiError } from './admin-organization-attrs.errors';
import { SoulfileProject } from 'src/app/admin/models/soulfile-project.model';

export const AdminLoadStockDigitalPeople = createAction(
  '[Admin Organization Attrs] Load Stock Digital People',
);

export const AdminSetStockDigitalPeople = createAction(
  '[Admin Organization Attrs] Set Stock Digital People',
  props<{ stocks: string[] }>(),
);

export const AdminLoadCurrentOrganizationAttrs = createAction(
  '[Admin Organization Attrs] Load Current Organization Attrs',
  props<{ id: number }>(),
);

export const AdminSetCurrentOrganizationAttrs = createAction(
  '[Admin Organization Attrs] Set Current Organization Attrs',
  props<{ attrs: AdminOrganizationAttrs }>(),
);

export const AdminLoadDefaultDPs = createAction('[Admin Organization Attrs] Load Default DPs');

export const AdminSetDefaultDPs = createAction(
  '[Admin Organization Attrs] Set Default DPs',
  props<{ dps: SoulfileProject[] }>(),
);

export const AdminCreateOrganizationAttrs = createAction(
  '[Admin Organization Attrs] Create Organization Attrs',
  props<{
    organizationId: number;
    values: AdminOrganizationAttrsValues;
  }>(),
);

export const AdminDeleteOrganizationAttrs = createAction(
  '[Admin Organization Attrs] Delete Organization Attrs',
  props<{ id: number }>(),
);

export const AdminSetOrganizationAttrsError = createAction(
  '[Admin Organization Attrs] Set Organization Attrs Error',
  props<{ error: AdminOrganizationAttrsApiError }>(),
);

export const AdminRemoveOrganizationAttrsError = createAction(
  '[Admin Organization Attrs] Remove Organization Attrs Error',
);
